import React from 'react';
import { useNavigate } from 'react-router-dom';

const totalQueries = 12;
const lastQuerySubmittedDate = '18 July 2026, 12:09';

export default function QueryDetails({ totalCount = 88 }) {
  const navigate = useNavigate();

  return (
    <section className="ca-query-details" aria-labelledby="query-management-title">
      <div className="ca-query-details__heading">
        <div className="ca-query-details__title-row">
          <button
            type="button"
            className="ca-settings-page__back"
            onClick={() => navigate('/')}
            aria-label="Back to Complaint Management"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M15 6l-6 6 6 6"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h1 id="query-management-title" className="ca-query-details__title">
            Query Management
          </h1>
        </div>
        <span className="ca-query-details__count">Total Count: {totalCount}</span>
      </div>

      <div className="ca-query-details__summary">
        <div className="ca-query-details__card">
          <span className="ca-query-details__label">Total Queries</span>
          <strong className="ca-query-details__value">{totalQueries}</strong>
        </div>
        <div className="ca-query-details__card">
          <span className="ca-query-details__label">Last Query Submitted Date</span>
          <strong className="ca-query-details__value">{lastQuerySubmittedDate}</strong>
        </div>
      </div>
    </section>
  );
}